<template>
	<div class="notification" :class="{ 'show' : getIsNotificationVisible }">{{ notificationtext }}</div>
</template>

<script>
	import { types } from "@/app/types/types";

	export default {
		name: "Notifications",
		data()
		{
			return {

			}
		},
		computed:
		{
			notificationtext()
			{
				// log("notificationtext")
				var notification = this.$store.getters[types.GET_NOTIFICATION_SHOWN]

				if (notification)
				{
					return notification.message
				}

				return ""
			},
			getIsNotificationVisible()
			{
				return this.$store.getters[types.GET_IS_NOTIFICATION_SHOWN]
			}
		}
	};
</script>